import React from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {setStripMassage, pageLoaded} from '../../fundialSlice';
import StripMessages from '../../../../Shared/StripMessages/StripMessages';

const PurpleWrapper = (props) => {

  function onMessageShow(isShow){
    props.setStripMassage({isShow:isShow, isErrorMsg: props.stripMassage.isErrorMsg , message: props.stripMassage.message });
  }


  return (
    <div className='purple-wrapper'>
      <div className='top-img'>
        <h1>
          {props.titleRegular && <span className='thin-title'>{props.titleRegular}&nbsp;</span>}
          {props.titleBold}
        </h1>
      </div>
      <Container>
          <Row className="justify-content-md-center">
            <Col xs="12" sm="12" md="10">
                    <div className='purple-wrapper-main'>{props.children}</div>
            </Col>
          </Row>
      </Container>
      <StripMessages onMessage={onMessageShow} isShowStrip={props.stripMassage.isShow} isErrorMsg={props.stripMassage.isErrorMsg} message={props.stripMassage.message} timeout={3000} isSlide={true} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    titleBold: state.fundialPage.navigation.titleBold,
    titleRegular: state.fundialPage.navigation.titleRegular,
    stripMassage: state.fundialPage.stripMassage
  };
};

const mapDispatchToProps = {
  setStripMassage,
  pageLoaded
};

export default connect(mapStateToProps, mapDispatchToProps)(PurpleWrapper);
